export interface IStaticState {
    staticFinSumData: Array<JSON>;
    staticThemesData: Array<JSON>;
    staticFinSumRenderComplete: boolean;
    staticCWRenderComplete: boolean;
}

export const STATIC_STATE: IStaticState = {
    staticFinSumData: [],
    staticThemesData: [],
    staticFinSumRenderComplete: false,
    staticCWRenderComplete: false,
};
